import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import { useFormInputProps } from "../Form"
import { useValidationElementProps } from "../Validation"

export type Props = ComponentPropsWithoutRef<"input">

/*
 * this input element consumes the form context and validation context so that
 * it can update the form validity state and the input validation messages
 */
export const UnstyledInput = forwardRef<HTMLInputElement, Props>(
  function UnstyledInput(props: Props, propRef: Ref<HTMLInputElement>) {
    // injects all properties used for check form validity
    const formInputProps = useFormInputProps(props)

    // injects all properties used for showing validation messages
    const validationElementProps = useValidationElementProps(
      formInputProps,
      propRef,
    )

    return (
      <input {...validationElementProps} />
    )
  },
)
